module.exports = __webpack_public_path__ + "static/media/dashboard-greyLeft-arrow.7e30e2db.png";